var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.9dc365385613596dfb62e3ce5fdbc6e0.js */ "./node_modules/.federation/entry.9dc365385613596dfb62e3ce5fdbc6e0.js");
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};